module.exports = __webpack_public_path__ + "static/img/14000576.9ee2302b.png";